"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withLeadingZero = void 0;
const withLeadingZero = (str) => {
    const strUpdate = typeof str === "number" ? str.toString(10) : str;
    if (strUpdate.length < 2) {
        return `0${strUpdate}`;
    }
    return strUpdate;
};
exports.withLeadingZero = withLeadingZero;
